import {Modal, Button} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'

interface Props {
  show: boolean
  title: string
  description: string
  confirmLabel?: string
  confirmVariant?: 'primary' | 'danger'
  loading?: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const ModalConfirmAction: React.FC<Props> = ({
  show,
  title,
  description,
  confirmLabel = 'Confirmar',
  confirmVariant = 'primary',
  loading,
  onCancel,
  onConfirm,
}) => {
  const intl = useIntl()
  return (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{description}</Modal.Body>
    <Modal.Footer>
      <Button variant='light' onClick={onCancel} disabled={loading}>
        <FormattedMessage id='common.action.cancel' defaultMessage='Cancel' />
      </Button>
      <Button variant={confirmVariant} onClick={onConfirm} disabled={loading}>
        {loading ? intl.formatMessage({id: 'leads.kanban.processing', defaultMessage: 'Processing...'}) : confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
  )
}
